import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  AJOUTER_PARAMETRE,
  LISTE_PARAMETRE_CONFIG,
} from "../../Utils/constant";
import { store } from "../../services/service";
import { useConfigStore } from "../../store/ConfigStore";

export const Configuration = () => {
  const param = useConfigStore();
  const [submitting, setSubmitting] = useState(null); // stores param key being submitted
  const [values, setValues] = useState({});

  const config = [
    {
      id: 1,
      description: "Nombre d'opérations par équipe",
      param: "TOTALE_OPERATION",
      defaultValue: param?.data?.TOTALE_OPERATION,
      message: "Distance de localisation appliquée",
      type: "number",
    },
    {
      id: 2,
      description: "Distance PBO (kilomètre)",
      param: "DISTANCE_PBO",
      defaultValue: param?.data?.DISTANCE_PBO,
      message: "Distance PBO appliquée",
      type: "number",
    },
    {
      id: 3,
      description: "Afficher le champ SN lors de la livraison",
      param: "CHAMPS_SN",
      defaultValue: param?.data?.CHAMPS_SN,
      message: "Configuration SN appliquée",
      type: "boolean",
    },
    {
      id: 4,
      description: "Attribution automatique des rendez-vous en attente",
      param: "ATTRIBUTION_AUTOMATIQUE_RDV",
      defaultValue: param?.data?.ATTRIBUTION_AUTOMATIQUE_RDV,
      message: "Configuration appliquée",
      type: "boolean",
    },
    {
      id: 5,
      description: "Afficher le champ Numéro d'avantage",
      param: "CHAMPS_NUMERO_AVANTAGE",
      defaultValue: param?.data?.CHAMPS_NUMERO_AVANTAGE,
      message: "Numéro d'avantage appliqué",
      type: "boolean",
    },
    {
      id: 6,
      description: "Afficher le champ OTP",
      param: "CHAMPS_OTP",
      defaultValue: param?.data?.CHAMPS_OTP,
      message: "Configuration OTP appliquée",
      type: "boolean",
    },
  ];

  useEffect(() => {
    param.getData(LISTE_PARAMETRE_CONFIG);
  }, []);

  useEffect(() => {
    if (param?.data) {
      const toStr = (v) => (v !== undefined && v !== null ? String(v) : "");
      setValues({
        TOTALE_OPERATION: param.data?.TOTALE_OPERATION ?? "",
        DISTANCE_PBO: param.data?.DISTANCE_PBO ?? "",
        CHAMPS_SN: toStr(param.data?.CHAMPS_SN),
        ATTRIBUTION_AUTOMATIQUE_RDV: toStr(
          param.data?.ATTRIBUTION_AUTOMATIQUE_RDV,
        ),
        CHAMPS_NUMERO_AVANTAGE: toStr(param.data?.CHAMPS_NUMERO_AVANTAGE),
        CHAMPS_OTP: toStr(param.data?.CHAMPS_OTP),
      });
    }
  }, [param?.data]);

  const handleApply = (item) => {
    const valeur = values[item.param] ?? "";
    setSubmitting(item.param);
    store(`${AJOUTER_PARAMETRE}`, "application/json", {
      designation: item.param,
      valeur,
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success(item.message);
          param.getData(LISTE_PARAMETRE_CONFIG);
        }
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.donnee || "Erreur lors de l'enregistrement",
        );
      })
      .finally(() => setSubmitting(null));
  };

  return (
    <div className="mt-4">
      <p className="text-2xl font-bold text-gray-900 tracking-tight mb-1">
        Configuration
      </p>
      <p className="text-sm text-gray-400 mb-6">
        Paramètres système de l'application
      </p>

      <div className="bg-white border border-gray-200 rounded-2xl divide-y divide-gray-100 overflow-hidden max-w-2xl">
        {config.map((item) => {
          const isLoading = submitting === item.param;
          const isBool = item.type === "boolean";

          return (
            <div
              key={item.id}
              className="flex items-center justify-between gap-4 px-5 py-4"
            >
              {/* Label */}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-800">
                  {item.description}
                </p>
                <p className="text-xs text-gray-400 mt-0.5">{item.param}</p>
              </div>

              {/* Control + Button */}
              <div className="flex items-center gap-2 shrink-0">
                {isBool ? (
                  <select
                    value={values[item.param] ?? ""}
                    onChange={(e) =>
                      setValues((s) => ({ ...s, [item.param]: e.target.value }))
                    }
                    className="h-9 w-28 text-center border border-gray-200 rounded-lg text-sm font-medium text-gray-800 bg-gray-50 outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-100 transition"
                  >
                    <option value="">--</option>
                    <option value="true">OUI</option>
                    <option value="false">NON</option>
                  </select>
                ) : (
                  <input
                    value={values[item.param] ?? item.defaultValue ?? ""}
                    onChange={(e) =>
                      setValues((s) => ({ ...s, [item.param]: e.target.value }))
                    }
                    type="text"
                    className="h-9 w-28 text-center border border-gray-200 rounded-lg text-sm font-medium text-gray-800 bg-gray-50 outline-none"
                  />
                )}

                <button
                  onClick={() => handleApply(item)}
                  disabled={!!submitting}
                  className={`h-9 px-4 rounded-lg text-xs font-semibold transition-all duration-150 flex items-center gap-1.5 ${
                    isLoading
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : "bg-yellow-400 hover:bg-yellow-300 text-gray-900"
                  }`}
                >
                  {isLoading ? (
                    <>
                      <span className="loading loading-spinner loading-xs" />
                      <span>Envoi…</span>
                    </>
                  ) : (
                    "Appliquer"
                  )}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
